import { reactive, toRefs } from 'vue';
import createAuth0Client from '@auth0/auth0-spa-js';

const DEFAULT_REDIRECT_CALLBACK = () => window.history.replaceState({}, document.title, window.location.pathname);

let instance;

export const getInstance = () => instance;

export const useAuth0 = ({
  onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
  redirectUri = window.location.origin,
  ...options
}) => {
  if (instance) return instance;

  const state = reactive({
    loading: true,
    isAuthenticated: false,
    user: {},
    auth0Client: null,
    popupOpen: false,
    error: null,
  });

  const methods = {
    async handleRedirectCallback() {
      state.loading = true;
      try {
        await state.auth0Client.handleRedirectCallback();
        state.user = await state.auth0Client.getUser();
        state.isAuthenticated = true;
        state.error = null;
      } catch (e) {
        state.error = e;
      } finally {
        state.loading = false;
      }
    },
    loginWithRedirect(o) {
      return state.auth0Client.loginWithRedirect(o);
    },
    getIdTokenClaims(o) {
      return state.auth0Client.getIdTokenClaims(o);
    },
    getTokenSilently(o) {
      return state.auth0Client.getTokenSilently(o);
    },
    logout(o) {
      return state.auth0Client.logout(o);
    },
  };

  (async () => {
    state.auth0Client = await createAuth0Client({
      ...options,
      client_id: options.clientId,
      redirect_uri: redirectUri,
    });
    try {
      if (window.location.search.includes('code=') && window.location.search.includes('state=')) {
        const { appState } = await state.auth0Client.handleRedirectCallback();
        state.error = null;
        onRedirectCallback(appState);
      }
    } catch (e) {
      state.error = e;
    } finally {
      state.isAuthenticated = await state.auth0Client.isAuthenticated();
      state.user = await state.auth0Client.getUser();
      state.loading = false;
    }
  })();

  instance = { ...toRefs(state), ...methods };
  return instance;
};

export const Auth0Plugin = {
  install(app, options) {
    app.config.globalProperties.$auth = useAuth0(options);
  },
};
